import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const originalFetch = window.fetch;
window.fetch = function (url, options = {}) {
  const token = localStorage.getItem('token');
  if (token && typeof url === 'string' && url.includes('/api/')) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  return originalFetch.call(this, url, options);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

